export default {
  workstation: {
    tabs: {
      workstation: "Workstation",
      trend: "Trend",
    },
    filters: {
      with: "With",
      without: "Without",
      splits: "Splits",
      none: "None",
    },
    sections: {
      gamelog: "Gamelog",
    },
    headers: {
      line: "Line",
      opponent: "Opponent",
    },
    labels: {
      averagePerGame: "Average per game",
      cover: "Cover",
    },
  },
};